<div class="nav-container" [ngClass]="{ 'is-open': isOpen() }">
  <!-- Backdrop -->
  <div class="backdrop" (click)="onClose()" tabindex="0" (keydown.enter)="onClose()"></div>

  <!-- Menu Panel -->
  <aside class="menu-panel">
    <!-- Header -->
    <div class="menu-header">
      <span class="logo-text brand-gradient">Haulverse</span>
      <app-button variant="ghost" [iconOnly]="true" icon="x" (click)="onClose()" />
    </div>

    <!-- Navigation -->
    <nav class="nav-main">
      @for (item of navService.topNavItems(); track item.label) {
        @if (item.section) {
          <div class="px-3 pt-3 pb-1 text-[10px] font-bold uppercase tracking-wider text-muted-foreground/60 select-none">
            {{ item.section }}
          </div>
        }
        <a [routerLink]="item.route" routerLinkActive="active" class="nav-item" (click)="onClose()">
          <lucide-icon [name]="item.icon" class="nav-icon"></lucide-icon>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      }
    </nav>

    <!-- Footer -->
    <div class="menu-footer">
      @for (item of navService.bottomNavItems(); track item.label) {
        @if (item.route) {
          <a [routerLink]="item.route" routerLinkActive="active" class="nav-item" (click)="onClose()">
            <lucide-icon [name]="item.icon" class="nav-icon"></lucide-icon>
            <span class="nav-label">{{ item.label }}</span>
          </a>
        } @else if (item.handler) {
          <button type="button" (click)="item.handler(); onClose()" class="nav-item">
            <lucide-icon [name]="item.icon" class="nav-icon"></lucide-icon>
            <span class="nav-label">{{ item.label }}</span>
          </button>
        }
      }
    </div>
  </aside>
</div>